import { render, staticRenderFns } from "./detalleFactura.vue?vue&type=template&id=6c6ae4e0"
import script from "./detalleFactura.vue?vue&type=script&lang=js"
export * from "./detalleFactura.vue?vue&type=script&lang=js"
import style0 from "./detalleFactura.vue?vue&type=style&index=0&id=6c6ae4e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports